import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';
import { formatDuration } from '../utils/workouts';
import { formatDistance } from '../utils/activities';
import './WorkoutView.css';
import './ActivityDetails.css';

// Общая статистика выполненных тренировок папки вместе с подпапками —
// для Outdoor. Считает бэкенд (Workout.activity_stats); reloadKey меняется,
// когда тренировки загрузили, перенесли или удалили
const ActivityStats = ({ folderId, reloadKey }) => {
  const { t } = useLanguage();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get('/api/workouts/stats', { params: { folder_id: folderId } })
      .then((res) => { if (!cancelled) setStats(res.data); })
      .catch(() => { if (!cancelled) setStats(null); });
    return () => { cancelled = true; };
  }, [folderId, reloadKey]);

  if (!stats || stats.count === 0) return null;

  // Не у всех заездов есть датчик: «по 5 из 12» — по скольким посчитано среднее
  const coverage = (count) => (count < stats.count
    ? t('workouts.stats.coverage').replace('{{count}}', count).replace('{{total}}', stats.count)
    : null);
  const tiles = [
    { label: t('workouts.stats.count'), value: stats.count },
    { label: t('workouts.stats.distance'), value: formatDistance(stats.distance_m), unit: t('workouts.activity.units.km') },
    { label: t('workouts.stats.time'), value: formatDuration(stats.duration_seconds) },
    stats.avg_power != null && {
      label: t('workouts.activity.avgPower'), value: stats.avg_power, unit: t('workouts.units.watts'), sub: coverage(stats.power_count),
    },
    stats.avg_heart_rate != null && {
      label: t('workouts.activity.avgHeartRate'), value: stats.avg_heart_rate, unit: t('workouts.activity.units.bpm'), sub: coverage(stats.heart_rate_count),
    },
  ].filter(Boolean);

  return (
    <section className="workout-tiles workout-tiles--activity" aria-label={t('workouts.stats.title')}>
      {tiles.map((tile) => (
        <div key={tile.label} className="workout-tile">
          <span className="workout-tile-label">{tile.label}</span>
          <span className="workout-tile-value">
            {tile.value}
            {tile.unit && <span className="workout-tile-unit"> {tile.unit}</span>}
          </span>
          {tile.sub && <span className="workout-tile-sub">{tile.sub}</span>}
        </div>
      ))}
    </section>
  );
};

export default ActivityStats;
